import {FC, useState, createContext, useContext} from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../_metronic/helpers'

const DLMLabelSetsQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const DLMLabelSetsQueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [state, setState] = useState<QueryState>(initialQueryRequest.state)

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  return (
    <DLMLabelSetsQueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </DLMLabelSetsQueryRequestContext.Provider>
  )
}

const useDLMLabelSetsQueryRequest = () => useContext(DLMLabelSetsQueryRequestContext)
export {DLMLabelSetsQueryRequestProvider, useDLMLabelSetsQueryRequest}
